<template>
    <article class="entry entry-agenda">
        <div class="row">
            <div class="hidden-xs col-sm-3 col-md-2">
                <img class="entry-thumbnail" v-if="post.thumbnail" :src="post.thumbnail">
            </div>
            <div class="col-xs-12 col-sm-9 col-md-10">
                <div class="row">
                    <div class="col-md-10">
                        <header>
                            <div class="entry-date">
                                {{ post.horaire }} <span v-if="post.lieu">/ {{ post.lieu }}</span>
                            </div>
                            <h4 class="entry-title" v-html="post.title.rendered"></h4>
                        </header>
                        <div v-if="post.resume" v-html="post.resume" class="entry-content"></div>
                    </div>
                    <div class="col-md-2">
                        <div class="two-blocks-red-link-container">
                            <a class="two-blocks-red-link" :href="postUrl">Découvrir</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </article>
</template>

<script>
  import _ from 'lodash'

  export default {

    props: {
      post: Object
    },

    computed: {

      postUrl () {
        return '/' + this.post.type + '/' + this.post.slug
      }

    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/agenda/AgendaEntry.vue